import React, { useState } from 'react'
import { CButton, CFormInput } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../../shared/icons'
import { useBostonState } from './lib/useBoston'
import { setSessionToken } from './lib/store'
import { useUI } from '../../shared/ui/UIProvider'

/* Token operativo de sesion Sabre (ATH:SHARED/...). Flujo original de boston_ia:
   prioridad URL ?token= → localStorage → vacio. Todas las llamadas lo usan en el header. */
function TokenBar() {
  const state = useBostonState()
  const { toast } = useUI()
  const [value, setValue] = useState(state.sessionToken || '')
  const active = Boolean(state.sessionToken)

  function save() {
    setSessionToken(value)
    toast(value.trim() ? 'Token guardado.' : 'Token vacio guardado.', value.trim() ? 'success' : 'warning')
  }

  function clear() {
    setSessionToken(null)
    setValue('')
    toast('Token limpiado.', 'info')
  }

  return (
    <div className="bia-token-bar card-x">
      <span className={`bia-token-dot ${active ? 'on' : 'off'}`} />
      <div className="bia-token-meta">
        <strong>Token de sesion Sabre</strong>
        <small>{active ? 'activo · todas las llamadas usan este token' : 'sin token · llamadas usaran apiKey de fallback'}</small>
      </div>
      <CFormInput
        size="sm"
        className="bia-mono bia-token-input"
        placeholder="ATH:SHARED/... (se captura solo desde ?token= en la URL)"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => event.key === 'Enter' && save()}
      />
      <CButton size="sm" color="success" className="btn-brand" onClick={save}>
        <CIcon icon={icon('cilSave')} /> Guardar
      </CButton>
      <CButton size="sm" color="light" onClick={clear}>
        <CIcon icon={icon('cilTrash')} /> Limpiar
      </CButton>
    </div>
  )
}

export default TokenBar
